import { render, staticRenderFns } from "./Property-Address.vue?vue&type=template&id=01b5d2b6"
import script from "./Property-Address.vue?vue&type=script&lang=js"
export * from "./Property-Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports